export const REGIONS = [
  {
    name: "Occitanie",
    highlight: true,
    cities: ["Toulouse", "Montauban", "Albi", "Castres", "Carcassonne", "Narbonne", "Tarbes", "Auch", "Cahors", "Rodez", "Foix", "Montpellier", "Perpignan", "Nîmes", "Béziers"],
  },
  {
    name: "Nouvelle-Aquitaine",
    cities: ["Bordeaux", "Mérignac", "Pessac", "Bayonne", "Pau", "La Rochelle", "Limoges", "Poitiers", "Angoulême", "Agen", "Biarritz"],
  },
  {
    name: "Auvergne-Rhône-Alpes",
    cities: ["Lyon", "Grenoble", "Saint-Étienne", "Clermont-Ferrand", "Annecy", "Valence", "Chambéry", "Villeurbanne"],
  },
  {
    name: "Provence-Alpes-Côte d'Azur",
    cities: ["Marseille", "Aix-en-Provence", "Nice", "Toulon", "Avignon", "Antibes", "Cannes", "Arles"],
  },
  {
    name: "Île-de-France",
    cities: ["Paris", "Boulogne-Billancourt", "Saint-Denis", "Versailles", "Créteil", "Nanterre", "Argenteuil"],
  },
  {
    name: "Autres régions",
    cities: ["Nantes", "Rennes", "Lille", "Strasbourg", "Dijon", "Orléans", "Reims", "Le Havre", "Brest", "Tours", "Nancy", "Metz"],
  },
];

// Stylized hexagon map of France: approximate positions (0-100 viewbox) of key cities
export const MAP_CITIES = [
  { name: "Lille", x: 50, y: 6, region: "Autres régions" },
  { name: "Strasbourg", x: 76, y: 20, region: "Autres régions" },
  { name: "Paris", x: 47, y: 22, region: "Île-de-France" },
  { name: "Rennes", x: 20, y: 28, region: "Autres régions" },
  { name: "Nantes", x: 22, y: 40, region: "Autres régions" },
  { name: "Dijon", x: 64, y: 32, region: "Autres régions" },
  { name: "Lyon", x: 62, y: 46, region: "Auvergne-Rhône-Alpes" },
  { name: "Grenoble", x: 68, y: 54, region: "Auvergne-Rhône-Alpes" },
  { name: "Clermont-Ferrand", x: 50, y: 48, region: "Auvergne-Rhône-Alpes" },
  { name: "Limoges", x: 38, y: 52, region: "Nouvelle-Aquitaine" },
  { name: "La Rochelle", x: 24, y: 54, region: "Nouvelle-Aquitaine" },
  { name: "Bordeaux", x: 26, y: 68, region: "Nouvelle-Aquitaine" },
  { name: "Pau", x: 32, y: 84, region: "Nouvelle-Aquitaine" },
  { name: "Toulouse", x: 42, y: 79, region: "Occitanie", home: true },
  { name: "Montpellier", x: 58, y: 83, region: "Occitanie" },
  { name: "Marseille", x: 66, y: 84, region: "Provence-Alpes-Côte d'Azur" },
  { name: "Nice", x: 80, y: 76, region: "Provence-Alpes-Côte d'Azur" },
  { name: "Montauban", x: 36, y: 72, region: "Occitanie" },
  { name: "Carcassonne", x: 48, y: 90, region: "Occitanie" },
  { name: "Aix-en-Provence", x: 71, y: 74, region: "Provence-Alpes-Côte d'Azur" },
];
